module.exports = "/_next/static/images/img__candidates_desktop-f1a984092e76707b3df664eda751f28a.png";